<div class="component-container">
    <table-panel header="Placówki własne" class="flex flex-grow"
        newOneTitle="Nowa placówka" (createNewOne)="createNew()"
        [compTableFlag]="false">
        <pr-new-table
            panel-body
            class="flex flex-grow"
            [dataService]="storesService"
            [columnsData]="columnsData"
            [tableId]="tableId"
            [navigationArr]="navigateLinkArr"
            [canNavigate]="true"
            [sortBy]="sortBy"
        >
        </pr-new-table>
    </table-panel>
</div>
